import TABLE_ICONS from './table-icons';

const REMOTE_APP_CONFIG_ENDPOINT = 'https://remote-app-config-6amhealth.herokuapp.com/admin';

const ENVIRONMENTS = {
  LOCAL: 'LOCAL',
  PROD: 'PROD',
  QA: 'QA',
};

const TAB_PATHS = {
  FRIDGES: '/fridges',
  ORDERS: '/orders',
  POS_SALES: '/pos-sales',
  POS_DOWNLOADS: '/pos-downloads',
  USERS: '/users',
  PROMOTIONS: '/promotions',
  PRODUCTS: '/products',
  COMPANIES: '/companies',
  POS_DEVICES: '/pos-devices',
  NOTIFICATIONS: '/notifications',
  SETTINGS: '/settings',
  INVENTORY: '/inventory',
};

const getEnvironment = () => {
  switch (window.location.origin) {
    case 'http://localhost:8080':
      return ENVIRONMENTS.QA; // LOCAL if running local server

    case 'https://admin-qa.6amhealth.com':
      return ENVIRONMENTS.QA;

    case 'https://admin.6amhealth.com':
      return ENVIRONMENTS.PROD;

    default:
      return ENVIRONMENTS.QA;
  }
};

export {
  getEnvironment,
  REMOTE_APP_CONFIG_ENDPOINT,
  TAB_PATHS,
  TABLE_ICONS,
};
